import { render, staticRenderFns } from "./RemoteDocumentWarningDataTable.vue?vue&type=template&id=6fb94d87&scoped=true"
import script from "./RemoteDocumentWarningDataTable.vue?vue&type=script&lang=js"
export * from "./RemoteDocumentWarningDataTable.vue?vue&type=script&lang=js"
import style0 from "./RemoteDocumentWarningDataTable.vue?vue&type=style&index=0&id=6fb94d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb94d87",
  null
  
)

export default component.exports